import Vue from 'vue';
import router from './router';
import App from './App.vue';
import store from "@/services/store";
import 'bootstrap';
import {route} from "@/constants";
import {VERIFY_AUTH} from "@/services/store/auth.module";
import {GIST_GET} from "@/services/store/gist.module";
import "@/services/store/firebase.module";
import {LOG_EVENT} from "@/services/store/firebase.module";

Vue.config.productionTip = false;

router.beforeEach(async (to, from, next) => {
    const authenticated = await store.dispatch(VERIFY_AUTH);

    if (authenticated) {
        if ((to.name === route.LIST || to.name === route.COVERS) && store.getters.getList === null) {
            await store.dispatch(GIST_GET).catch((e) => {
                let exception = '';

                if (e.response) {
                    exception = JSON.stringify({data: e.response.data, status: e.response.status});
                } else if (e.request) {
                    exception = JSON.stringify(e.request);
                } else {
                    exception = e.message;
                }
                this.$store.commit(LOG_EVENT, {name: 'exception', data: {description: exception}});
                next({name: route.ERROR});
            });
        }

        next();
    } else {
        if (to.name === route.DISCLAIMER) {
            next();
        } else {
            next({name: 'disclaimer'});
        }
    }
});

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
